import { Result } from "antd";
import React from "react";

const NotFound = () => {
  return <Result status={"404"} title="Not Found" />;
};

export default NotFound;
